// AUTO-GENERATED FILE: This file is automatically generated when you create a custom component
// using `yarn create-custom-component <ComponentName>`. This is a starting template that you
// can and should edit to set your component's schema URL and type.
// Single source of truth for schemaUrl and componentType
// Used by both admin and guest configs
export const STAY_BOOKING_ASSISTANT_SCHEMA_URL = 'https://heygirl.cutestperson.com/assets/public/schemas/stayBookingAssistant_V2_0_1.json' as const;
export const STAY_BOOKING_ASSISTANT_COMPONENT_TYPE = 'StayBookingAssistant' as const;

// Mode options
export enum StayBookingAssistantMode {
  Simple = 'simple',
  Advanced = 'advanced',
}

// Layout options for advanced mode
export enum AdvancedModeLayout {
  SimpleHotelList = 'simpleHotelList',
  HotelTilesCarousel = 'hotelTilesCarousel',
}

// Layout options for simple mode photo
export type SimpleModePhotoLayout = 'pageWidth' | 'screenWidth';

export const SimpleModePhotoLayout = {
  PageWidth: 'pageWidth' as const,
  ScreenWidth: 'screenWidth' as const,
} as const;

// Preview image URLs for photo layout options
export const PHOTO_LAYOUT_PREVIEW_IMAGES = {
  pageWidth: 'https://heygirl.cutestperson.com/assets/public/photo-layouts/brannan-pageWidth.jpg',
  screenWidth: 'https://heygirl.cutestperson.com/assets/public/photo-layouts/brannan-fullWidth.jpg',
} as const;

export const HOTELS_PER_PAGE_MOBILE = 3;
export const HOTELS_PER_PAGE_DESKTOP = 3;
